import React, { useState, useEffect } from 'react';
import dateFormat from 'dateformat';
import styled from 'styled-components';

import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import isGreaterThanDate from '@stencil/date-utils/src/isGreaterThanDate';
import { CalendarView } from '@stencil/dcalendar';
import { ONWARD, RETURN } from '@stencil/flights-constants/src/text';

const maxAllowedRoomNights = 20;

const CalendarBlock = React.forwardRef(
  (
    props: {
      isSearchWidget;
      isDeparture;
      isArrival;
      onSelection;
      handleOnDateClick;
      departure;
      arrival;
      getFareData;
      fareCalendarData;
    },
    ref
  ) => {
    const {
      isSearchWidget,
      isDeparture,
      isArrival,
      onSelection,
      handleOnDateClick,
      departure,
      arrival,
      getFareData,
      fareCalendarData
    } = props;

    const [mode, setMode] = useState(isDeparture ? ONWARD : RETURN);

    useEffect(() => {
      if (getFareData) {
        getFareData(mode);
      }
    }, []);

    const getClassName = (dateObj: Date, selectedDate) => {
      if (
        dateObj.getMonth() === selectedDate.getMonth() &&
        dateObj.getDate() === selectedDate.getDate() &&
        dateObj.getFullYear() === selectedDate.getFullYear()
      ) {
        return 'complete';
      }
      // if (
      //   departure &&
      //   dateObj.getMonth() === departure.getMonth() &&
      //   dateObj.getDate() === departure.getDate() &&
      //   dateObj.getFullYear() === departure.getFullYear()
      // ) {
      //   return 'complete';
      // }
      // if (
      //   arrival &&
      //   dateObj.getMonth() === arrival.getMonth() &&
      //   dateObj.getDate() === arrival.getDate() &&
      //   dateObj.getFullYear() === arrival.getFullYear()
      // )
      //   return 'rightactive';
      // if (
      //   departure &&
      //   arrival &&
      //   dateObj.getTime() > departure.getTime() &&
      //   dateObj.getTime() < arrival.getTime()
      // )
      //   return 'partial';
      return '';
    };

    const dateOnClickHandler = dateObj => {
      if (isDeparture) {
        handleOnDateClick({
          departure: getDateObject(dateObj)
        });
        onSelection();
      } else {
        handleOnDateClick({
          arrival: getDateObject(dateObj)
        });
        onSelection();
      }
    };

    const todaysDate = new Date();

    const maxDateAllowed = new Date();
    maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
    if (isArrival) {
      maxDateAllowed.setDate(maxDateAllowed.getDate() + maxAllowedRoomNights);
    }

    return (
      <CalendarBlockOuterWrapper ref={ref} isSearchWidget={isSearchWidget}>
        <CalendarView
          dateConfigForMonthToBeDisplayed={isDeparture ? departure.dateObj : arrival.dateObj}
          minDateAllowed={isDeparture ? todaysDate : departure.dateObj}
          maxDateAllowed={maxDateAllowed}
          extendedComponent={null}
          renderDateItem={({ value, dateObj, index }) => {
            const { data = null, stats = null } = fareCalendarData || {};
            const yyyymmdd = dateFormat(dateObj, 'yyyymmdd');

            let price = 0;
            if (value && data && data[yyyymmdd]) {
              price = data[yyyymmdd].p;
            }

            if (!value) {
              return (
                <li key={index}>
                  <span></span>
                </li>
              );
            }

            let isValid = true;

            dateObj.setHours(0, 0, 0, 0);

            if (isDeparture) {
              todaysDate.setHours(0, 0, 0, 0);
              isValid =
                dateObj.getTime() >= todaysDate.getTime() &&
                dateObj.getTime() < maxDateAllowed.getTime();
            }

            if (isArrival) {
              departure.dateObj.setHours(0, 0, 0, 0);
              isValid = departure.dateObj.getTime() <= dateObj.getTime();
            }

            const isLessThanCurrentDate = isGreaterThanDate(new Date(), dateObj);
            const isOld = isLessThanCurrentDate || (mode === 'return' && !isValid);
            const isMinimun = stats && stats.min && price && price === stats.min ? true : false;
            const spanClass = getClassName(dateObj, arrival ? arrival.dateObj : departure.dateObj);
            const isSelected = spanClass === 'complete';

            return (
              <li
                key={index}
                style={
                  isValid
                    ? { color: 'black', cursor: 'pointer' }
                    : { opacity: '0.4', color: 'grey', cursor: 'default' }
                }
                onClick={() => {
                  isValid ? dateOnClickHandler(dateObj) : () => {};
                }}
              >
                <span className={spanClass}>
                  {value}
                  <p
                    style={{
                      color: isSelected
                        ? '#ffffff'
                        : isOld
                        ? '#cbcbcb'
                        : isMinimun
                        ? '#0da078'
                        : '#0071e4',
                      fontSize: '10px'
                    }}
                  >
                    {price
                      ? `${price.toLocaleString('en-IN', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: 'currency',
                          currency: 'INR'
                        })}`
                      : dateObj
                      ? '-'
                      : ''}
                  </p>
                </span>
              </li>
            );
          }}
        />
      </CalendarBlockOuterWrapper>
    );
  }
);

export default CalendarBlock;

const CalendarBlockOuterWrapper = styled.div(
  props => `
    display: flex;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: 1.2rem;
    transform: translateY(4px);
  `
);
